module.exports = __webpack_public_path__ + "static/media/industry.f439e7c1.png";